module.exports = __webpack_public_path__ + "img/small-4.768c87ff.webp";